import { createSlice } from '@reduxjs/toolkit';

export const bilsoftSlice = createSlice({
    name: 'bilsoft',
    initialState: {
        codeList: [],
        companyReq: [
            {
                title: 'E Defter Şube Adı',
                value: ''
            },
            {
                title: 'E Defter Şube Kodu',
                value: ''
            },
            {
                title: 'Vergi Numarası',
                value: ''
            }
        ],
        webServiceReq: null,
        programReq: null,
        databaseFetchLoading: false,
        availableDatabases: [],
        loginSuccess: false,
        loginToken: null
    },
    reducers: {
        setCodeList: (state, action) => {
            state.codeList = action.payload;
        },
        addNewCode: (state, action) => {
            state.codeList.push(action.payload);
        },
        deleteCode: (state, action) => {
            state.codeList = state.codeList.filter((item) => item.enum !== action.payload.enum);
        },
        updateCompanyReq: (state, action) => {
            state.companyReq = state.companyReq.map((item) => {
                if (item.title === action.payload.title) {
                    item.value = action.payload.value;
                }
                return item;
            });
        },
        setWebservicesReq: (state, action) => {
            state.webServiceReq = action.payload;
        },
        updateWebServiceReq: (state, action) => {
            state.webServiceReq[action.payload.title] = action.payload.value;
        },
        setProgramReq: (state, action) => {
            state.programReq = action.payload;
        },
        updateProgramReq: (state, action) => {
            state.programReq[action.payload.title] = action.payload.value;
        },
        setDatabaseFetchLoading: (state, action) => {
            state.databaseFetchLoading = action.payload;
        },
        setAvailableDatabases: (state, action) => {
            state.availableDatabases = action.payload;
        },
        setLoginSuccess: (state, action) => {
            state.loginSuccess = action.payload;
        },
        setLoginToken: (state, action) => {
            state.loginToken = action.payload;
        },
        clearAllBilsoft: (state) => {
            state.codeList = [];
            state.companyReq = [
                {
                    title: 'E Defter Şube Adı',
                    value: ''
                },
                {
                    title: 'E Defter Şube Kodu',
                    value: ''
                },
                {
                    title: 'Vergi Numarası',
                    value: ''
                }
            ];
            state.webServiceReq = null;
            state.programReq = null;
            state.databaseFetchLoading = false;
            state.availableDatabases = [];
            state.loginSuccess = false;
            state.loginToken = null;
        }
    }
});

export const { setCodeList, addNewCode, deleteCode, updateCompanyReq, updateWebServiceReq, setWebservicesReq, setProgramReq, updateProgramReq, setDatabaseFetchLoading, setAvailableDatabases, setLoginSuccess, setLoginToken, clearAllBilsoft } =
    bilsoftSlice.actions;

export default bilsoftSlice.reducer;
